export class MobbexCredentialRequest {
  cuit: string;
  splitTrx: boolean;
  entityUid: string;
}
